import { useGetIdentity, useList } from '@refinedev/core';
import { Select } from 'antd';
import type { User } from '@/types';
import { getImpersonatedRental, startImpersonation } from '@/services/auth';
import { isAdmin } from '@/types/models';

type RentalOption = {
  id: string;
  name: string;
  slug: string;
};

// Starts an Impersonation from Global view. ImpersonationBanner shows and ends it.
export const RentalSwitcher = (): React.JSX.Element | null => {
  const { data: user } = useGetIdentity<User>();
  const isVisible = !!user && isAdmin(user) && !getImpersonatedRental();

  const { result, query } = useList<RentalOption>({
    resource: 'rentals',
    queryOptions: {
      enabled: isVisible,
    },
  });

  if (!isVisible) {
    return null;
  }

  const rentals = result.data;

  const handleStartImpersonation = async (rentalId: string): Promise<void> => {
    const rental = rentals.find((r) => r.id === rentalId);
    if (!rental) return;

    await startImpersonation(rental);
  };

  return (
    <Select<string>
      className="app-header__rental-switcher"
      placeholder="Switch to rental..."
      loading={query.isLoading}
      showSearch
      optionFilterProp="label"
      onChange={(value: string) => {
        void handleStartImpersonation(value);
      }}
      options={rentals.map((rental) => ({
        value: rental.id,
        label: rental.name,
      }))}
    />
  );
};
